
    <div class="cf">
        <div class="tabheadingsoverflow">
            <div class="d-flex financial-hdr">
                <!--<h2 class="mainhead">
                    <span class="text">{{price?.longName}}</span>     
                    <span class="sub-text">{{price?.symbol}} - {{price?.quoteSourceName}} - Currency in USD</span>
                </h2>-->
                <h2 class="mainhead mr-auto">
                    <span class="text">{{price?.longName}}</span><br />
                    <span  class="sub-text" *ngIf="price?.quoteSourceName">{{price?.symbol}} - {{price?.quoteSourceName}} - Currency in USD</span>
                </h2>
                <div *ngIf="price?.symbol" class="symbol-box">
                    <span [style.color]="getColorForStock(price?.regularMarketPrice)" style="font-size:20px;font-weight:500;"> {{price?.regularMarketPrice}}</span> &nbsp;
                    <span [style.color]="getColorForStock(price?.regularMarketChange)" style="font-size:13px;font-weight:400;"> {{price?.regularMarketChange}}</span>
                    <span [style.color]="getColorForStock(price?.regularMarketChangePercent)">
                        ({{price?.regularMarketChangePercent}})
                    </span>
                    <p class="inf-text" style="max-width: 295px;font-size:13px;">

                        <span>
                            As Of
                            {{price?.regularMarketTime*1000| date:'MM/dd/yyyy hh:mm a'}}
                        </span>
                    </p>
                </div>
            </div>
            <div class="floatinghead be-tab-02 clearfix" style="margin:0;" *ngIf="showSummaryTab && tickerAvailable">

                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a href="javascript:void(0);" [class.active]="financialSummaryActiveTab == financialSummaryTabs.Summary" (click)="financialSummaryTabClick(financialSummaryTabs.Summary);">
                            Summary
                        </a>
                    </li>

                    <li class="nav-item">
                        <a href="javascript:void(0);" [class.active]="financialSummaryActiveTab == financialSummaryTabs.Profile" (click)="financialSummaryTabClick(financialSummaryTabs.Profile);">
                            Profile
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:void(0);" [class.active]="financialSummaryActiveTab == financialSummaryTabs.Financials" (click)="financialSummaryTabClick(financialSummaryTabs.Financials);">
                            Financials
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:void(0);" [class.active]="financialSummaryActiveTab == financialSummaryTabs.Statistics" (click)="financialSummaryTabClick(financialSummaryTabs.Statistics);">
                            Statistics
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:void(0);" [class.active]="financialSummaryActiveTab == financialSummaryTabs.Chart" (click)="financialSummaryTabClick(financialSummaryTabs.Chart);">
                            Chart
                        </a>
                    </li>
                </ul>

            </div>
        </div>
        <div class="section-margin" *ngIf="showSummaryTab">
            <div class="container container-lg margin-bottom-20">
                <div class="row">
                    <div *ngIf="financialSummaryActiveTab == financialSummaryTabs.Summary && showSummary">
                        <app-summary-tab [tickerSymbol]="tickerSymbol" [tenant]="tenant" [summaryData]="summaryData"></app-summary-tab>
                    </div>
                    <div *ngIf="financialSummaryActiveTab == financialSummaryTabs.Profile">
                        <app-profile-tab [tickerSymbol]="tickerSymbol"></app-profile-tab>
                    </div>
                    <div *ngIf="financialSummaryActiveTab == financialSummaryTabs.Chart">
                        <app-summary-tab [tickerSymbol]="tickerSymbol" [isChart]="true"></app-summary-tab>
                    </div>
                    <div *ngIf="financialSummaryActiveTab == financialSummaryTabs.Financials">
                        <app-financials [tickerSymbol]="tickerSymbol"></app-financials>
                    </div>
                    <div *ngIf="financialSummaryActiveTab == financialSummaryTabs.Statistics">
                        <app-statistics [tickerSymbol]="tickerSymbol"></app-statistics>
                    </div>
                </div>
            </div>
        </div>

    </div>

